import React from "react";

import { ConfirmationModal } from "src/base-components/ConfirmationModal";
import { BeMappedNode } from "src/constants/NodeDataTypes";

export type ConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  branchToDeleteName: string;
  branchCount?: number;
  nodesToDelete: BeMappedNode[];
};

export const SplitBranchDeletionModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  branchToDeleteName,
  branchCount = 1,
  nodesToDelete,
  onConfirmDelete,
}) => {
  const isMultipleBranches = branchCount > 1;
  const renderDeleteMessage = () => (
    <div className="text-gray-500 font-inter-normal-12px">
      Are you sure you want to delete{" "}
      {isMultipleBranches ? `these ${branchCount} branches` : "this branch"}?
      This cannot be undone.{" "}
      {nodesDownstream.length !== 0 &&
        "The following nodes down stream will also be deleted:"}
    </div>
  );

  const renderNodeToDeleteMessage = () => (
    <div className="my-2">
      {nodesDownstream.map((node: BeMappedNode) => (
        <div
          key={node.id}
          className="ml-2 text-gray-500 font-inter-medium-12px"
        >
          • {node.data?.label}
        </div>
      ))}
    </div>
  );

  const nodesDownstream = nodesToDelete.filter(
    (node: BeMappedNode) => node.data.label !== branchToDeleteName,
  );

  return (
    <ConfirmationModal
      open={open}
      title={
        isMultipleBranches
          ? `Delete ${branchCount} branches?`
          : "Delete branch?"
      }
      onClose={onClose}
      onConfirm={onConfirmDelete}
    >
      {renderDeleteMessage()}
      {nodesToDelete.filter(
        (node: BeMappedNode) => node.data.label !== branchToDeleteName,
      ).length !== 0 && <>{renderNodeToDeleteMessage()}</>}
    </ConfirmationModal>
  );
};
